module.exports = __webpack_public_path__ + "img/企事业餐饮运营托管服务5.bca4d0e5.jpg";